module.exports = __webpack_public_path__ + "img/screen-agrupador-01.a949eb65.png";